export default __webpack_public_path__ + "static/media/generalErrorImage.1b2683a8.svg";